var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(" This feature is available for CG Elite members only. "),_c('a',{attrs:{"href":_vm.link,"target":"_blank","rel":"noopener noreferrer"}},[_vm._v(" Click here ")]),_vm._v(" to learn more about becoming a CG Elite member "),_c('br'),_c('br')])
}
var staticRenderFns = []

export { render, staticRenderFns }